import React, { useState } from "react";
import {
  PaymentElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import "../components/PaymentForm.css";

interface PaymentFormProps {
  type: string;
  amount: number;
  orderID: number;
  suranID?: string;
  onClose: (message?: string) => void;
}

const PaymentForm: React.FC<PaymentFormProps> = ({
  type,
  amount,
  orderID,
  suranID,
  onClose,
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const [message, setMessage] = useState<string | null>(null);
  const [loadingSpinner, setLoadingSpinner] = useState(false);

  const APP_URL = process.env.REACT_APP_APP_URL || "";
  const DEV_APP_URL = process.env.REACT_APP_DEV_APP_URL || "";
  const PROD_APP_URL = process.env.REACT_APP_PROD_APP_URL || "";

  const siteBaseUrl =
    window.location.hostname === "localhost"
      ? APP_URL
      : window.location.hostname === new URL(PROD_APP_URL).hostname
      ? PROD_APP_URL
      : DEV_APP_URL;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!stripe || !elements) {
      console.log("Stripe or elements not ready");
      return;
    }
    setLoadingSpinner(true);
    setMessage(null);

    let result;

    if (type === "suran" && suranID) {
      result = await stripe.confirmPayment({
        elements,
        confirmParams: {
          return_url: `${siteBaseUrl}/suran/payment/${suranID}?orderID=${orderID}`,
        },
      });
    } else {
      result = await stripe.confirmPayment({
        elements,
        confirmParams: {
          return_url: `${siteBaseUrl}/candidate?orderID=${orderID}`,
        },
      });
    }

    const { error } = result;

    if (error) {
      if (error.type === "card_error" || error.type === "validation_error") {
        console.log(error.message || "Payment processing error");
      } else {
        setMessage("An unexpected error occurred.");
        console.log("An unexpected error occurred.");
      }
    }

    setLoadingSpinner(false);
  };

  return (
    <>
      <div className="background-mask" onClick={() => onClose()}></div>
      <div className="filter-popup-xl">
        <div className="close-button-container">
          <button className="close-button" onClick={() => onClose()}>
            <i className="bi bi-x-circle"></i>
          </button>
        </div>
        <div className="payment-text">
          <h2>Submit Payment</h2>
          <div>
            The submission of this background check requires an authorization
            payment.
          </div>
        </div>
        <div className="dialog-container">
          <form id="payment-form">
            <PaymentElement id="payment-element" />
            <button
              className="button-payment"
              disabled={!stripe || !elements}
              onClick={handleSubmit}
            >
              <span id="button-text">Pay ${amount}</span>
            </button>
            {message && <div id="payment-message">{message}</div>}
          </form>
        </div>
      </div>
      {loadingSpinner && (
        <div className="loading-mask">
          <div className="loading-spinner"></div>
        </div>
      )}
    </>
  );
};

export default PaymentForm;
